import { render, staticRenderFns } from "./StackingBlockCard.vue?vue&type=template&id=62d3d41c&scoped=true"
import script from "./StackingBlockCard.vue?vue&type=script&lang=js"
export * from "./StackingBlockCard.vue?vue&type=script&lang=js"
import style0 from "./StackingBlockCard.vue?vue&type=style&index=0&id=62d3d41c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d3d41c",
  null
  
)

export default component.exports